import React, { useEffect, useMemo } from 'react'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import styled from 'styled-components'
import { useLocation } from 'react-router-dom'
import { grey } from '@mui/material/colors'

import TextAnalysisHeader from './Header'
import TextAnalysisFilters from './Filters'
import TextAnalysisContent from './Content'
import { useAppDispatch } from 'redux/Hook'
import { fetchContributions } from 'redux/thunks/TextAnalysis'

/**
 * height 4rem => base container has padding 32px of top & bottom
 */
const Wrapper = styled(Box)<{ $tapage: boolean }>`
  display: flex;
  min-height: ${({ $tapage }) => ($tapage ? '100vh' : 'calc(100vh - 4rem)')};
  padding: ${({ $tapage }) => ($tapage ? '0 2.5rem 0 2.5rem' : 0)};
  background-color: ${({ $tapage }) => ($tapage ? grey[100] : 'transparent')};

  @media only screen and (max-width: 700px) {
    padding: ${({ $tapage }) => ($tapage ? '0 1rem' : 0)} !important;
  }
`

const TextAnalysis = () => {
  const dispatch = useAppDispatch()
  const location = useLocation()
  const isAdminTAPage = useMemo(
    () => location.pathname.startsWith('/adm/text_analysis'),
    [location.pathname],
  )

  useEffect(() => {
    dispatch(fetchContributions())
  }, [dispatch])

  return (
    <Wrapper flexGrow={1} $tapage={!isAdminTAPage} data-testid="ta-dashboard">
      <Grid container>
        <TextAnalysisHeader />
        <TextAnalysisFilters />
        <TextAnalysisContent />
      </Grid>
    </Wrapper>
  )
}

export default React.memo(TextAnalysis)
